export const paymentStatusLable={
    ORDERWITHOUTPAYMENT:'Order Created Without Payment',
    PENDINGCONFIRMPAYMENT : 'Payment Is Pending',
    PAYMENTCOMPLETED : 'Payment Is Completed',
    PAYMENTERROR : 'Error in Payment',
    PAYMENTCANCELED: 'Payment Canceled'
}